import { LTText } from '@lambdatestincprivate/lt-components';
import { LinkIcon, LockIcon, ShieldCheckIcon } from '@primer/octicons-react';
import styles from './landing.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TRUST = [{
  icon: LockIcon,
  text: 'Opens in your browser, never uploaded'
}, {
  icon: ShieldCheckIcon,
  text: 'Sealed when the run ended'
}, {
  icon: LinkIcon,
  text: 'Anyone with the file can open it'
}];

/**
 * The trust-notes footer pinned to the bottom of the pre-open screens
 * (Landing + the opening/unpack screen). Shared so both stay identical;
 * `dim` fades it back while a file is dragged over the window.
 */
export function TrustFooter(_ref) {
  var _ref$dim = _ref.dim,
    dim = _ref$dim === void 0 ? false : _ref$dim;
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(styles.openingFooter).concat(dim ? " ".concat(styles.dimmed) : ''),
    children: TRUST.map(function (_ref2, i) {
      var Icon = _ref2.icon,
        text = _ref2.text;
      return /*#__PURE__*/_jsxs("span", {
        className: styles.footerItem,
        children: [i > 0 && /*#__PURE__*/_jsx("span", {
          className: styles.footerDivider,
          "aria-hidden": "true"
        }), /*#__PURE__*/_jsx("span", {
          className: styles.trustIcon,
          "aria-hidden": "true",
          children: /*#__PURE__*/_jsx(Icon, {
            size: 15
          })
        }), /*#__PURE__*/_jsx(LTText, {
          as: "span",
          text: text,
          variant: LTText.TextVariant.SMALL_REGULAR,
          color: "var(--lt-text-secondary)"
        })]
      }, text);
    })
  });
}